import React, { forwardRef } from "react";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";

const CustomPhoneInput = forwardRef(
  (
    {
      label,
      value,
      name,
      onChange,
      required = false,
      className = "",
      placeholder = "Phone Number",
      defaultCountry = "IN",
      international = true,
      error,
      ...props
    },
    ref
  ) => {
    return (
      <div className={`w-full ${className}`}>
        {label && (
          <label className="flex text-sm font-normal text-slate-500 mb-1 text-nowrap items-center gap-1">
            {label}
            {required ? (
              <span className="text-red-500 text-xl">*</span>
            ) : (
              <span className="text-xl">&nbsp;</span>
            )}
          </label>
        )}
        <div className={`phone-input-wrapper ${error ? "error" : ""}`}>
          <PhoneInput
            name={name}
            ref={ref}
            international={international}
            defaultCountry={defaultCountry}
            value={value}
            withCountryCallingCode
            onChange={onChange}
            placeholder={placeholder}
            className={`phone-input-container ${
              error ? "border-red-500" : "border-slate-300"
            }`}
            {...props}
          />
        </div>
        {error && <p className="mt-1 text-xs text-red-500">{error}</p>}
      </div>
    );
  }
);

CustomPhoneInput.displayName = "CustomPhoneInput";

export default CustomPhoneInput;
